import styled from 'styled-components'

const ListItemDescription = styled.dd`
  color: #999999;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default ListItemDescription
